import {  useEffect, useMemo, useState } from "react";
import {
  addContactsToCampaign,
  findConactsFromVendorForNurture,
  generateTempalteByContacts,
  nurtureContactSearchSave
} from "../../../../../../services/iqApiV2";
import SearchedContactResult from "./SearchedContactResult";
import { useDispatch, useSelector } from "react-redux";
import SimpleThemedButton from "../../../../genericComponents/simpleTextField/SimpleThemedButton";
import { useUser } from "../../../../../../context/UserContext";
import { FetchSpotContactsRequest } from "../../../../../../store/features/actions/targetedReachout/spotContactsActions";
import { parseContact, parseCSV, STEP_IDS } from "../../../../../../utilities/uiUtils";

function NurtureCampaignContactMinimal({
  currentCampDetails,
  stepDispatch,
  stepId,
  searchHist,
  setSearchHist,
  selectedContacts,
  setSelectedContacts,
  setCurrentStepIndex,
  domain,
  skipSearch=false
}) {
  console.log("NurtureCampaignContactMinimal domain", currentCampDetails);
  const [searchedContacts, setSearchedContacts] = useState([]);
  const [disableForward,setDisableForward]=useState(false)
  
  const [submitInProgress, setSubmitInProgress] = useState(false);

  const { user } = useUser();
  const { spotContactsData = [], spotContactsLoading } = useSelector(
    (state) => state?.spotContactsReducer || {}
  );

  const reduxDispatch = useDispatch();

  useEffect(() => {
    reduxDispatch(
      FetchSpotContactsRequest({
        clientName: user?.company_name,
        accountName: currentCampDetails?.account,
        userId: user?.id,
      })
    );
  }, []);

  const spotContactsDataIDS = useMemo(
    () =>
      Array.isArray(spotContactsData)
        ? spotContactsData.map((i) => i?._id).filter(Boolean)
        : [],
    [spotContactsData]
  );
const gotNutureEmail = () => {

  if (activeTab !="SELECTED") {
    setActiveTab("SELECTED");
    return null;
  }
  setSubmitInProgress(true);

  const searchList = {
    domain: domain,
    titles: searchHist?.titles ?? [],
    person_locations: searchHist?.person_locations ?? [],
    person_seniorities: searchHist?.person_seniorities ?? [],
    page: 1,
    per_page: 50,
    currentStepId: STEP_IDS.CONTACT,
  };

  addContactsToCampaign(
    currentCampDetails?.campaignId,
    (selectedContacts ?? []).map(parseContact),
    searchList
  )
    .then(async(resp) => {
      if (resp?.success !== 200) {
        throw new Error("addContactsToCampaign failed");
      }

      const contacts = resp?.inserted ?? [];
      const processedContacts=contacts?.map(parseContact)
      setSelectedContacts(processedContacts);


  
      if (!contacts.length) return [];

      const accountsStr = Array.isArray(currentCampDetails?.account)
        ? (currentCampDetails?.account ?? []).join(",")
        : (currentCampDetails?.account ?? "") || "";

        const contactIds =  contacts?.map(
           (element) => element?._id
        );
         generateTempalteByContacts(
                       user?.company_name ?? "",
            accountsStr,
            // productsStr,
            currentCampDetails?.campaignName ?? "",
            currentCampDetails?.campaignContext ?? "",
           contactIds,
           user?.id,
            currentCampDetails?.campaignId
                      )


           
           setSubmitInProgress(false);
            stepDispatch?.({ type: "MARK_COMPLETED", payload: stepId });
      setCurrentStepIndex?.((prev) => prev + 1);
    })
};

 const [totalEntries,setTotalEntries]=useState(0);
  const handleSearchForContacts = async (searchObj) => {
    console.log("searchObj", searchObj);
    setSearchHist({
      titles: searchObj?.titles,
      person_locations: searchObj?.person_locations,
      person_seniorities: searchObj?.person_seniorities,
    });

    try {
      const payload = {
        domain: parseCSV(domain), // https://www.marketsandmarkets.com/
        titles: searchObj?.titles,
        // keywords: [],
        person_locations: searchObj?.person_locations,
        person_seniorities: searchObj?.person_seniorities,
        page: searchObj?.page,
        per_page: searchObj?.per_page,
      };
      const res = await findConactsFromVendorForNurture(payload);


      //make api call to store search params
      try {
        const searchList = {
        domain: domain, // https://www.marketsandmarkets.com/
        titles: searchObj?.titles,
        person_locations: searchObj?.person_locations,
        person_seniorities: searchObj?.person_seniorities,
        page: searchObj?.page,
        per_page: searchObj?.per_page,
        currentStepId: currentCampDetails?.lastStep ? currentCampDetails?.lastStep: STEP_IDS.CAMPAIGN_INIT,
          };


          await nurtureContactSearchSave(
            currentCampDetails?.campaignId,
            searchList
          ) 
      } catch (error) {
        console.log("error while saving search param",error)
      }
       
     
      setTotalEntries(res?.data?.pagination?.total_entries);
       console.log("deep contacts",res?.data?.contacts)
      setSearchedContacts(res?.data?.contacts || []);
    } catch (err) {
      console.error("Search error:", err);
    }
  };
  useEffect(() => {
    handleSearchForContacts({
      titles: searchHist?.titles,
      person_seniorities: searchHist?.person_seniorities,
      person_locations: searchHist?.person_locations,
      page: 1,
        per_page: 5,
    });
  }, []);
   const [activeTab, setActiveTab] = useState(skipSearch?"SELECTED":"FIND");
  return (
    <div>
      
        <SearchedContactResult
          handleSearchForContacts={handleSearchForContacts}
          searchHist={searchHist}
          searchedContacts={searchedContacts}
          selectedContacts={selectedContacts}
          setSelectedContacts={setSelectedContacts}
          spotContactsDataIDS={spotContactsDataIDS}
          totalEntires={totalEntries}
          activeTab={activeTab} setActiveTab={setActiveTab}
          skipSearch={skipSearch}
          user={user}
          account={currentCampDetails?.account}
           disableForward={disableForward}
          setDisableForward={setDisableForward}
          campaignId={currentCampDetails?.campaignId}
        />
      

     <div
          style={{
            position: "fixed",
            width: "100%",
            
            zindex: "1000",
            borderTop: "1px solid #E2E8F0",
            right:"0rem",
            bottom: "0rem",
            padding:"0.5rem",
     
            backgroundColor: "#F2F6FB",
            display: "flex",
            justifyContent: "flex-end",
            display:"flex",
            alignItems:"center"
          }}
        >
       { selectedContacts?.length > 50 &&  <span style={{marginRight:"30px", fontSize:'14px', fontWeight:'600'}}>Select Contacts Not More Than 50</span>}
       {activeTab !== "SELECTED" ? (
        <SimpleThemedButton
          btnDisabled={
            selectedContacts?.length === 0 ||
            selectedContacts?.length > 50 ||
            submitInProgress
          }
          buttonText="Preview Selected Contacts ->"
          onBtnClick={gotNutureEmail}
          isLoading={submitInProgress}
        />
      ) : (
        <SimpleThemedButton
          btnDisabled={
            selectedContacts?.length === 0 ||
            selectedContacts?.length > 50 ||
            submitInProgress||
            disableForward
          }
          buttonText="Continue to Email Reachout ->"
          onBtnClick={gotNutureEmail}
          isLoading={submitInProgress}
        />
      )}

      </div>
    </div>
  );
}

export default NurtureCampaignContactMinimal;
